export default __webpack_public_path__ + "static/media/EM1750.34I-41297_-24637_0.536fe250.jpg";